// extracted by mini-css-extract-plugin
module.exports = {"card":"SimpleDataLinkCard_card__2wFNR"};